import { render, staticRenderFns } from "./TemplatePlate.vue?vue&type=template&id=5db2d788"
import script from "./TemplatePlate.vue?vue&type=script&lang=js"
export * from "./TemplatePlate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports